<template>
  <div class="select-all-content">
    <a-modal
      title="请选择菜品或套餐"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="modalLoading"
      :zIndex="99999"
      width="600px"
    >
      <a-form layout="inline" class="drawForm" style="margin-bottom: 10px;">
        <a-form-item
          :label-col="{ span: 12 }"
          :wrapper-col="{ span: 12 }"
          label="发布份数："
        >
          <a-input-number :min="1" v-model="amount" />
        </a-form-item>
      </a-form>
      <a-table
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: getCheckboxProps
        }"
        :scroll="getScrollHeight"
        :loading="tableLoading"
        :bordered="true"
        :columns="columns"
        :dataSource="tableData"
        :pagination="false"
      >
        <span slot="imgUrl" slot-scope="text">
          <a-avatar
            :src="text ? text : 'images/noImg.jpg'"
            shape="square"
            size="large"
            style="margin:0 2px;"
          />
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>

const columns = [
  {
    title: '菜品名称',
    dataIndex: 'name'
  },
  {
    title: '图片',
    dataIndex: 'imgUrl',
    scopedSlots: { customRender: "imgUrl" },
    width: 120,
    align: 'center'
  },
  {
    title: '菜品类型',
    dataIndex: 'menuTypeName',
    width: 120,
    align: 'center'
  },
  {
    title: '单价/元',
    dataIndex: 'defaultUnitPrice',
    width: 120,
    align: 'center'
  }
];

export default {
  data() {
    return {
      columns,
      selectedRowKeys: [],
      selectedRows: [],
      amount: 10
    };
  },
  computed: {
    getScrollHeight() {
      return { y: window.innerHeight - 340 }
    }
  },
  props: {
    publishMenuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    modalLoading: {
      type: Boolean,
      default: false
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    getCheckboxProps(record) {
      const tempIndex = this.publishMenuList.findIndex(item => {
        if (item.isPackage) {
          return item.packageCode === record.code
        } else {
          return item.menuId === record.id
        }
      })
      if (record.isPackage) {
        return {
          props: {
            disabled: tempIndex !== -1, // Column configuration not to be checked
            code: String(record.code)
          }
        }
      } else {
        return {
          props: {
            disabled: tempIndex !== -1, // Column configuration not to be checked
            id: String(record.id)
          }
        }
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    showModal() {
      this.$emit("showModal")
    },
    handleOk(e) {
      this.$emit('handleOk', this.selectedRows, this.amount)
    },
    handleCancel(e) {
      this.$emit("hideModal")
    }
  },
  watch: {
    visible(newVal, oldVal) {
      if (!newVal) {
        this.selectedRowKeys = []
        this.selectedRows = []
      }
    }
  }
}
</script>
